import React from "react";

const Mobile = (props) => {

	const prop = props;

	return (
		<div className="container-search-sort">
			<select className="sort-search" id="sort-search" onChange={prop.handleSorting}>
				<option value="popular">Popular</option>
				<option value="newest">Newest</option>
				<option value="high_rating">Highest Ranking</option>
				<option value="low_rating">Lowest Ranking</option>
				<option value="high_price">Highest Price</option>
				<option value="low_price">Lowest Price</option>
			</select>

			<style jsx>
				{`
					select#sort-search{
						border-radius: 8px;
						border: 1px solid #DFE3E8;
						background: #FFF;
						color: #13161A;
						font-size: 14px;
						font-family: 'Creato Display';
						padding: 6px 10px;
						padding-right: 30px;

						appearance: none; /* Remove default styling, if supported */
						-webkit-appearance: none; /* Remove default styling for Safari */
						-moz-appearance: none; /* Remove default styling for Firefox */
						background: url('/images-newfdbr/chevron-down.svg') no-repeat right 5px center; /* Add a custom arrow image */
						background-size: 20px; 
					}
					option#sort-search { 
						background-color: #ffff;
						font-size: 14px;
						font-family: 'Creato Display';
						line-height: 22px;
					}

					.sort-search:focus {
  border-color: #e0e0e0;
}
				`}
			</style>

		</div>
	);

};

export default Mobile;
